import {
  COMMON_BOOLEAN_MAP,
  projectStatusMap
} from '@components/ProjectFromComponents/data';
import { ROLE_KEYS_MAP } from '@constants';
import { userInfo } from '@store';
import { valToString } from '@utils/tool';
import { dealerSectorArr } from '@views/pages/AnnouncementList/Announcement/CreateAnnouncement';
import { Col, Row } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useRecoilState } from 'recoil';
import { useImmer } from 'use-immer';
import {
  BiddingStatus,
  SALESFEED_COLUMNS,
  SALESFEED_COLUMNS_WAIT
} from './columns';
import './index.scss';

export const useSalesFeedBack = ({
  details,
  handleClickEditBtn,
  dict,
  leadsData
}: any) => {
  const [salesColumn, setSalesColumn] = useState(SALESFEED_COLUMNS);
  const [salesWaitColumn, setSalesWaitColumn] = useImmer(
    SALESFEED_COLUMNS_WAIT
  );
  const { coreLoseReason, coreWinReason } = dict;
  const [userInfos] = useRecoilState(userInfo);

  const isDealer = userInfos.roleKeys === ROLE_KEYS_MAP.dealer;

  const isVersion2 = dealerSectorArr.includes(valToString(details.sectorType));

  const reasonData =
    details.loseWinStatus == 1 ? coreWinReason : coreLoseReason;
  const loseOrWinReason =
    reasonData &&
    reasonData.filter((x: any) => x.dictKey == details.coreLoseReasonStatus);

  useEffect(() => {
    let tempArr = [];
    let oppId: any = [];
    if (details.opportunityStatus == 0) {
      oppId = (details.oppId || '')
        .split(',')
        .map((x: string, index: number) => {
          return {
            title: `Opp ID_0${index + 1}`,
            dataIndex: `oppId${index + 1}`,
            key: `oppId${index + 1}`,
            render: () => {
              return x;
            }
          };
        });
    }

    const filteredColumns = salesColumn.filter(
      (x) =>
        x.key !== 'prosNumStatus' &&
        x.key !== 'oldCustomerModel' &&
        !String(x.key).includes('oppId')
    );
    if (details.attendTenderStatus == 0 || details.oldCustomerStatus == 0) {
      if (details.attendTenderStatus == 0) {
        tempArr.push({
          title: '是否有Pros招投标号',
          dataIndex: 'prosNumStatus',
          key: 'prosNumStatus',
          render: (record: any) => {
            return record.prosNumStatus == null
              ? ''
              : record.prosNumStatus
              ? '否'
              : '是';
          }
        });
      }
      if (details.oldCustomerStatus == 0) {
        tempArr.push({
          title: '老客户机型',
          dataIndex: 'oldCustomerModel',
          key: 'oldCustomerModel'
        });
      }

      setSalesColumn([...filteredColumns, ...tempArr, ...oppId]);
    } else {
      setSalesColumn([
        ...filteredColumns.filter(
          (x) => x.key !== 'prosNumStatus' && x.key !== 'oldCustomerModel'
        ),
        ...oppId
      ]);
    }
  }, [
    details?.attendTenderStatus,
    details.oldCustomerStatus,
    details.opportunityStatus,
    details.oppId
  ]);

  useEffect(() => {
    if (details.opportunityStatus == 0) {
      const oppId = (details.oppId || '')
        .split(',')
        .map((x: string, index: number) => {
          return {
            title: `Opp ID_0${index + 1}`,
            dataIndex: `oppId${index + 1}`,
            key: `oppId${index + 1}`,
            render: () => {
              return x;
            }
          };
        });
      const filteredColumns = salesWaitColumn.filter(
        (x) => !x.key.includes('oppId')
      );
      setSalesWaitColumn([...filteredColumns, ...oppId]);
    } else {
      setSalesWaitColumn(
        salesWaitColumn.filter((x) => !x.key.includes('oppId'))
      );
    }
  }, [details.opportunityStatus, details.oppId]);

  const infoArr = useMemo(() => {
    const arr =
      details.subjectMatterProjectStatus == BiddingStatus['EndBidding']
        ? salesColumn
        : salesWaitColumn;

    return arr.filter((item: any) => {
      if (isDealer && item.key === 'opportunityStatus') {
        return false;
      } else if (item.key === 'createLeads') {
        return (
          details.subjectMatterProjectStatus ===
            projectStatusMap.waittingForTender &&
          valToString(details.opportunityStatus) === COMMON_BOOLEAN_MAP.no &&
          !isDealer
        );
      } else if (item.key === 'offlineFormId') {
        return details.offlineFormValue;
      } else if (item.key === 'subjectMatterProjectSaleName') {
        return !isDealer;
      } else if (item.key === 'corpName' || item.key === 'dealerUserName') {
        return details.corpName;
      } else if (item.key === 'LeadsIds') {
        return !isDealer && leadsData?.length;
      } else if (
        isVersion2 &&
        details.subjectMatterProjectStatus === projectStatusMap.endTender &&
        (item.key === 'coreLoseReasonStatus' ||
          item.key === 'oldCustomerStatus')
      ) {
        return false;
      } else if (item.key === 'offlineFormValue') {
        return isVersion2;
      }
      return true;
    });
  }, [salesColumn, salesWaitColumn, leadsData]);

  const salesFeedBackComponent = (
    <div className="pc-pro-container">
      <div className="pc-sub-tit">
        <div className="pc-sub-tit-text">销售反馈信息</div>
        {details?.deleteStatus ? null : (
          <a className="pc-detail-edit-btn" onClick={handleClickEditBtn}>
            编辑
          </a>
        )}
      </div>
      <Row gutter={[18, 18]}>
        {infoArr.map((x: any, index) => {
          return (
            <Col span={10} key={index} className="pc-info-flex">
              <div className="pc-info-label">{x.title} :</div>
              <div>
                {x.special === 'reason'
                  ? loseOrWinReason?.length
                    ? loseOrWinReason[0].dictValue
                    : ''
                  : x.render
                  ? x.render({
                      ...details,
                      leadsData
                    })
                  : details[x.key] || ''}
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );

  return {
    salesFeedBackComponent
  };
};
